import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, Query, ODataAdaptor  } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { DatePipe,DecimalPipe } from '@angular/common';
import { DashboardCounterModel } from "../../models/dashboard/dashboard-counter.model";
import { DashboardRequestModel } from "../../models/dashboard/dashboard-request.model";
import { IAxisLabelRenderEventArgs, ILoadedEventArgs, IPointRenderEventArgs } from '@syncfusion/ej2-angular-charts';
import { Chart, ChartTheme, IAccTextRenderEventArgs, IAccTooltipRenderEventArgs } from '@syncfusion/ej2-charts';
import {
    ChartComponent, AccumulationChartComponent, AccumulationChart
    , AccumulationDataLabel, IAccLoadedEventArgs, AccumulationTheme
} from '@syncfusion/ej2-angular-charts';
import { SidebarService } from '../../sidebar/sidebar.service';

@Component({
    selector: '',
    templateUrl: 'dashboard.html',
    styleUrls: ['./dashboard.css']
})
export class DashboardComponent implements OnInit {
    public primaryXAxis: Object;


    public palettesPie: string[] = ["#094658", "#f70519", "#29cfa2", "#e0841b", "#f2e01b", "#4a0580", "#1954d4", "#acf525", "#eb2a6a", "#35850b", "#29abcf", "#a64deb", "#ce2aeb"];
    palettesPieSOU: string[] = ["#073334", "#0b494a", "#0e5f61", "#117577", "#148b8d"];
    palettesPieNOR: string[] = ["#4b6430","#577638","#648741","#719849","#7ea951","#8bb361"];


    public pieData: Object[] = [];
    public pieSOUData: Object[] = [];
    public pieNORData: Object[] = [];


    public legendPieSettings: Object;
    public startAngle: number = 0;
    public endAngle: number = 360;
    public dataLabel: Object = {
        visible: true,
        name: 'PercentValue',
        position: 'Inside',
        font: {
            size: "13pt",
            fontWeight: '400',
            color: '#ffffff'
        }
    };
    public dataLabelByArea: Object = {
        visible: true,
        name: 'PercenValueByArea',
        position: 'Inside',
        font: {
            size: "13pt",
            fontWeight: '400',
            color: '#ffffff'
        }
    };
    public enableSmartLabelsPie: boolean=true;
    public enableAnimation: boolean = true;
    public radius: string = 'Radius';
    yearSelectd: string = "";
    titlePieChar: string = 'Tender classification in Value ($)';
    
    fields: Object = { text: 'label', value: 'value' };
    yearDDL: Array<any> = [];
    dashboardCounter: DashboardCounterModel = new DashboardCounterModel();//***********
    dashboardCounterRequest: DashboardRequestModel = new DashboardRequestModel();//

   
    public markerRequestDisplayColumn: Object = {
        dataLabel:
        {
            visible: true,
            position: 'Top',
            font: { fontWeight: '100', color: '#ffffff',size:"16px" },
            name: "TotalRequestDisplay",
        }
    };

    public tooltipPie: Object = {
        enable: true,
        format: '${point.tooltip}'
    };


    /* Column chart */
    public columnData: Object[] = [];
    titleColumnChart: string = "Total of request classification by area";
    public palettesColo: string[] = ["#094658"];
    public tooltipColumn: Object = {
        enable: true,
        format: '${point.tooltip}'
    };
    public primaryXAxisColChart: Object;
    

    public pointRender(args: IPointRenderEventArgs): void {
        let seriesColor: string[] = ["#117577", "#117577", "#117577", "#117577", "#117577", "#719849", "#719849", "#719849", "#719849", "#719849"];
        args.fill = seriesColor[args.point.index];
    };


    constructor(private http: HttpService, private helper: HelperService, public datepipe: DatePipe, private sidebar: SidebarService) {
       
    }

    ngOnInit() {        
        //this.yearData();
       // this.getDashboardCounter();         //get thong tin hang so 
       // this.getDashboardPieChart();        //bieu do Banh
       // this.getDashboardCloumnChart(); // column chart
       // this.primaryXAxis = {
       //     valueType: 'Category',
       // };
       // this.primaryXAxisColChart = {
       //     valueType: 'Category',

       //     labelStyle: {
       //         size: '12px', color: '#094658',
       //         fontFamily: 'Segoe UI', fontWeight: 'bold'
       //     }
       // };

    }

    getDashboardCounter() {

        this.http.get('api/Dashboard/GetDashboardCounterRequest/' + this.yearSelectd, res => {
            this.dashboardCounterRequest = res.Result;
        }, null);

    }
   
    getDashboardPieChart() {

        this.http.get('api/Dashboard/GetDashboardPieYTD/' + this.yearSelectd, res => {
            if (res.length > 0) {
                this.pieData = res;
                this.pieSOUData = res.filter(x => x.Mien == "NAM");
                this.pieNORData = res.filter(x => x.Mien == "BAC");
            }
        }, null);


        this.legendPieSettings = {
            visible: true,
            position: 'Top'
        };
    }

   
    getDashboardCloumnChart() {

        this.http.get('api/Dashboard/GetDashboardColumnTotalRequest/' + this.yearSelectd, res => {
            if (res.length > 0) {


                var tempArrSort = [];
                // south
                var hcm1 = res.filter(x => x.AreaName == "HCM1")[0];
                var hcm2 = res.filter(x => x.AreaName == "HCM2")[0];
                var hcm3 = res.filter(x => x.AreaName == "HCM3")[0];              
                var sou3 = res.filter(x => x.AreaName == "SOU3")[0];
                var mek2 = res.filter(x => x.AreaName == "MEK2")[0];
                var cen1 = res.filter(x => x.AreaName == "CEN1")[0];
                // north
                var hn1 = res.filter(x => x.AreaName == "HN1")[0];
                var hn2 = res.filter(x => x.AreaName == "HN2")[0];
                var nor1 = res.filter(x => x.AreaName == "NOR1")[0];
                var nor2 = res.filter(x => x.AreaName == "NOR2")[0];

                tempArrSort.push(hcm1);
                tempArrSort.push(hcm2);
                tempArrSort.push(hcm3);
                tempArrSort.push(sou3);
                tempArrSort.push(mek2);
                tempArrSort.push(cen1);
               
                tempArrSort.push(hn1);
                tempArrSort.push(hn2);
                tempArrSort.push(nor1);
                tempArrSort.push(nor2);
                this.columnData = tempArrSort;
            }
        }, null);
    }




    onActionFailure(e: Error): void {
        this.helper.alert(e.message);
    }
    yearData() {
        var yearNow = (new Date()).getFullYear();
        for (var year = (yearNow-4); year <= (yearNow + 4); year++) {
            var opt = { label: year.toString(), value: year.toString() };
            this.yearDDL.push(opt);
        };
        this.yearSelectd = yearNow.toString();
    }
    changeYearEvent(e) {
        this.yearSelectd = e.value;
        this.getDashboardCounter();
        this.getDashboardPieChart();
        this.getDashboardCloumnChart();
    }

   


}
